import React from "react";

export const ListSkeleton: React.FC<{
  count: number;
  skeletonHeight?: string;
  containerClassName?: string;
}> = (props) => {
  const printSekeletons = () => {
    const skeletons = new Array(props.count).fill(0);
    return skeletons.map((skeleton, index) => (
      <div
        key={`skeleton-${index}`}
        className={`list-skeleton mb-3 ${props.containerClassName}`}
      >
        <p className="placeholder-glow">
          <span
            className="placeholder col-12"
            style={{
              height: props.skeletonHeight || "80px",
            }}
          ></span>
        </p>

        <p className="placeholder-wave">
          <span
            className="placeholder col-12"
            style={{
              height: props.skeletonHeight || "80px",
            }}
          ></span>
        </p>
      </div>
    ));
  };

  return <React.Fragment>{printSekeletons()}</React.Fragment>;
};
